module.exports = __webpack_public_path__ + "img/cu.72cb307a.svg";